module.exports = __webpack_public_path__ + "static/media/kingsfoodmarkets.166531f0.svg";